<template>
  <div>
    <read-more :targetId="oneId + '_' + itemType" :text="item" :addMore="this.detailView" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
      {{item}}
    </read-more>
  </div>
</template>
<script>
import OneDropDown from '@/components/One/OneDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
export default {
  name: 'OneItem',
  components: {
    OneDropDown,
    ReadMore
  },
  props: {
    item: {
      type: String
    },
    detailView: {
      type: Boolean
    },
    oneId: {
      type: String,
      default: 'id'
    },
    itemType: {
      type: String,
      default: 'memo'
    }
  },
  data: function () {
    return {
      propShowMore: false,
      propContentHeight: 0
    }
  },
  methods: {
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/One/OneItem.vue